import type { RefObject } from 'react';
import type { TripRoute } from '@eti/schema-types';
import { breakpoints } from '@etg/wings';
import { useMediaQuery } from 'usehooks-ts';
import type { Filters } from '../search-filters/v3/MobileFilters';
import MobileFilters from '../search-filters/v3/MobileFilters';
import type { ResultSetMetaDataType } from '../../models';
import DesktopFilters from '../search-filters/v3/DesktopFilters';
import FloatingSaveTripButton from './FloatingSaveTripButton';

interface ResultSearchFiltersProps {
  filteredFlightsCount: number;
  flightsCount: number;
  isOpen: boolean;
  onClear: () => void;
  onDone: () => void;
  onFilter: (filter: any) => void;
  resultSetMetaData: ResultSetMetaDataType;
  searchRoutes: TripRoute[];
  selectedFilters?: Filters;
  sidebarRef: RefObject<HTMLElement>;
}

const ResultSearchFilters = ({
  sidebarRef,
  filteredFlightsCount,
  flightsCount,
  isOpen,
  onClear,
  onDone,
  onFilter,
  resultSetMetaData,
  searchRoutes,
  selectedFilters,
}: ResultSearchFiltersProps) => {
  const isMobile = useMediaQuery(`(max-width: ${breakpoints._970})`);

  return isMobile ? (
    <>
      <FloatingSaveTripButton />

      <MobileFilters
        filteredFlightsCount={filteredFlightsCount}
        isOpen={isOpen}
        onClear={onClear}
        onDone={onDone}
        onFilter={onFilter}
        resultSetMetaData={resultSetMetaData}
        searchRoutes={searchRoutes}
        selectedFilters={selectedFilters}
      />
    </>
  ) : (
    <DesktopFilters
      filteredFlightsCount={filteredFlightsCount}
      flightsCount={flightsCount}
      isOpen={isOpen}
      onClear={onClear}
      onDone={onDone}
      onFilter={onFilter}
      resultSetMetaData={resultSetMetaData}
      searchRoutes={searchRoutes}
      selectedFilters={selectedFilters}
      sidebarRef={sidebarRef}
    />
  );
};

export default ResultSearchFilters;
